<template>
    <div class="my-finance-withdraw">
        <div class="flexUser">
            <div>
                <p class="text">
                    {{ $t("accountPage.balance") }}
                    ({{ $t("accountPage.element") }})
                    <img loading="lazy"
                        v-lazy="require('../../../assets/images/dze/shuaxin.png')"
                        class="imgRefsh"
                        :class="{ shuaActive: refreshImgStart }"
                        @click="getGameMoneyList(true)"
                    />
                </p>
                <p class="text usermoney">
                    {{ $common.setNumFixed(userInfo.totalBalance, 2) }}
                </p>
            </div>
            <div class="btnOne buttonHover1" @click="onMergeGame">
                {{ $t("accountPage.collection") }}
            </div>
        </div>
        <div v-if="gameList.length > 0">
            <!-- <el-scrollbar class="scroll-style"> -->
            <ul class="ulBox">
                <li
                    class="itemBox"
                    v-for="(item, i) of gameList"
                    :key="i"
                    v-show="i <= total"
                >
                    <p class="vendor">{{ item.vendorName }}</p>
                    <p
                        v-if="item.operation"
                        :class="{ moneyColor: item.totalMoney != 0 }"
                    >
                        ￥{{ item.totalMoney.toFixed(2) }}
                    </p>
                    <p v-if="!item.operation">
                        {{ $t("accountPage.hand") }}
                    </p>
                </li>
                <li class="more" @click="onMore">
                    <img loading="lazy"
                        v-lazy="require('../../../assets/images/dze/daw.png')"
                        class="moreImg"
                        v-if="condition"
                    />
                   <img loading="lazy"
                        v-lazy="require('../../../assets/images/dze/up.png')"
                        class="moreImg"
                        v-if="!condition"
                   />
                </li>
            </ul>
            <!-- </el-scrollbar> -->
        </div>
        <div class="banklist">
            <div class="titleB">{{ $t("accountPage.getmoneyMode") }}:</div>
            <el-select
                v-model="backcardname"
                :placeholder="$t('accountPage.getMode')"
                class="selectbanks"
                :class="{ 'selectbank-img': backImg }"
                @change="onSelectbank($event)"
            >
                <template slot="prefix" v-if="backImg">
                    <el-image :src="backImg" class="prefixSlot">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </template>
                <el-option
                    v-for="item in bankArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                    <div style="text-align: left; width: 100%">
                        <!-- <img loading="lazy"
                            v-lazy="require('../../../assets/images/dze/shuaxin.png')"
                            v-if="item.type === 2"
                            class="bankimg"
                        /> -->
                        <el-image
                            :src="$common.getImgUrl(item.imgUrl)"
                            class="bankimg"
                        >
                            <div slot="error" class="image-slot"></div>
                        </el-image>
                        <p style="display: inline-block" v-if="item.type === 2">
                            {{
                                $t("accountPage.wallet") + "(" + item.name + ")"
                            }}
                        </p>
                        <p v-else style="display: inline-block">
                            {{ item | banktitle }}
                        </p>
                    </div>
                </el-option>
                <el-option v-if="bankCardList.length < bankCountNumber || usdtList.length < usdtCountNumber || walletList.length < walletCountNumber" :label="$t('accountPage.addbank')" value="add">
                    <div class="money-select-option-add-bank">
                        <div>
                            <i
                                class="el-icon-circle-plus-outline add-bank-img themeTextColor"
                            ></i>
                        </div>
                        <div class="add-text">
                            <span>{{ $t("accountPage.addbank") }}</span>
                        </div>
                        <div>
                            <i class="el-icon-arrow-right icon-right-img"></i>
                        </div>
                    </div>
                </el-option>
            </el-select>
        </div>

        <!-- <div class="addBank" v-if="bankArr.length == 0">
            <div @click="$router.push({ path: '/my/info/bankCard' })">
                <h2>{{ $t("drawingPage.nullbank") }}</h2>
                <p>{{ $t("drawingPage.now") }}</p>
            </div>
        </div> -->

        <div class="flexItem">
            <div class="flexName">{{ $t("drawingPage.getMoney") }}:</div>
            <div class="felxg">
                <div v-if="withdrawType" class="withdraw-buttom-box">
                    <div class="withdraw-buttom" :class="checkMoneyIndex === index ? 'withdraw-buttom-act' : '' " v-for="(item,index) in withdrawFixed" :key="'withdraw' + index" 
                    @click="checkMoney(item,index)">
                        {{ item }}
                    </div>
                </div>
                <div v-else>
                    <el-input
                        class="inputsele"
                        onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                        v-model="setmoney"
                        :placeholder="placeholderPhone"
                        @input="onChangePhone"
                    >
                        <template slot="suffix">
                            <span @click="getAllMoney">{{
                                $t("drawingPage.all")
                            }}</span>
                        </template>
                    </el-input>
                </div>
                <div class="tips">
                    <!-- <p v-if="backitemdata[0].type != 0">
                        1RMB≈{{ exchange | subNum }}{{ backitemdata[0].name }}
                    </p> -->
                    <!-- <p>当前可提款金额￥100.00，最小提现金额1USDT</p> -->
                    <p v-if="backitemdata[0].type != 0">
                        {{ $t("drawingPage.actual") }}：{{
                            ActualMoney.toFixed(2)
                        }}RMB≈{{ accMul(ActualMoney, exchange) }}USDT
                        <img loading="lazy"
                            v-lazy="require('../../../assets/images/dze/shuaxin.png')"
                            class="refshImg"
                        />
                    </p>
                    <p v-if="backitemdata[0].type == 0">
                        {{ $t("drawingPage.actual") }}：{{
                            ActualMoney.toFixed(2)
                        }}RMB
                        <img loading="lazy"
                            v-lazy="require('../../../assets/images/dze/shuaxin.png')"
                            class="refshImg"
                            @click="getCost(true)"
                        />
                    </p>
                    <p>
                        {{ $t("drawingPage.procedures") }}：￥
                        {{ $common.setNumFixed(handlingfee, 2) }}
                    </p>
                    <p>
                        {{ $t("drawingPage.expenses") }}：￥
                        {{ $common.setNumFixed(administrativeCosts, 2) }}
                    </p>
                    <p>
                        {{ $t("drawingPage.discount") }}：￥
                        {{ $common.setNumFixed(discountDeduction, 2) }}
                    </p>
                </div>
            </div>
        </div>
        <div class="flexItem">
            <div class="flexName">{{ $t("drawingPage.pawss") }}:</div>
            <div class="felxg">
                <el-input
                    class="inputsele"
                    v-model="moneyPassword"
                    type="password"
                    :placeholder="$t('drawingPage.inputPwass')"
                ></el-input>
            </div>
        </div>
        <div class="mytButton">
            <span class="btnConfirm" @click="onConfirm">{{
                $t("drawingPage.determine")
            }}</span>
        </div>

        <el-dialog :visible.sync="dialogVisible" width="25%" class="dialog">
            <div slot="title" class="header-title">
                {{ $t("accountPage.phoneget") }}
            </div>
            <div class="content">
                <div class="inputfelx">
                    <div class="label">{{ $t("accountPage.phone") }}</div>
                    <div class="input-p">
                        <el-input
                            v-model="mPhone"
                            :disabled="showPhone"
                            :placeholder="$t('accountPage.inputPhone')"
                        ></el-input>
                    </div>
                </div>
                <div class="inputfelx">
                    <div class="label">{{ $t("accountPage.code") }}</div>
                    <div>
                        <el-input
                            v-model="mCode"
                            :placeholder="$t('accountPage.inputcode')"
                        ></el-input>
                    </div>
                    <el-button class="btn-code" @click="getCode">
                        {{ codeButtext }}
                    </el-button>
                </div>
                <div>
                    <el-button class="btn-submit" @click="submitPhone">
                        {{ $t("accountPage.determine") }}</el-button
                    >
                </div>
            </div>
        </el-dialog>

        <el-dialog
            :title="$t('drawingPage.tip')"
            :visible.sync="dialogVisibletext"
            :center="true"
            width="20%"
        >
            <div class="dialogCentent">
                <div class="text" :class="{ centetr: centerIs }">
                    {{ textTips }}
                </div>
                <div class="btnBox">
                    <el-button
                        class="btn-submit"
                        @click="dialogVisibletext = false"
                    >
                        {{ $t("drawingPage.determine") }}</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    filters: {
        banknumber(val) {
            if (val) {
                return val.substr(0, 4) + " **** **** " + val.substr(-4);
            } else {
                return;
            }
        },
        banktitle(val) {
            if (val) {
                return val.name + "(" + val.number.substr(-4) + ")";
            } else {
                return;
            }
        },
        subNum(val) {
            var re = /([0-9]+\.[0-9]{6})[0-9]*/;
            let aNew = (val + "").replace(re, "$1");
            return aNew;
        },
    },
    data() {
        return {
            dialogVisible: false,
            mPhone: "",
            mCode: "",
            codeButtext: "获取验证码",
            refreshImgTime: false,
            refreshImgStart: false,
            showPhone: false,
            selectBank: false,
            OneKey: false,
            total: 19,
            condition: true,
            backImg: "", //选中银行图片
            backcardname: "",
            walletimg: require("../../../assets/images/dze/daw.png"),
            backitemdata: [{ type: 0 }],
            userData: {},
            gameList: [],
            exchange: "", //汇率
            digitBuyRate: "", //转换前的汇率
            currencyName: "", //货币名称
            calculate: "", //计算最小提现金额
            actualAmount: "", //实际到账金额
            handlingfee: 0, //手续费
            handlingfees: 0,
            withdrawPayRate:0, //百分比
            administrativeCosts: 0, //行政费用,
            discountDeduction: 0, //优惠扣除
            ActualMoney: 0, //实际到账金额
            placeholderPhone: "请输入提款金额",
            singleMax: null,
            singleMin: null,
            SureMoney: 0, //可提现金额
            setmoney: "",
            moneyPassword: "",
            dialogVisibletext: false,
            centerIs: false,
            textTips: "",
            bankCountNumber: 0, // 可绑定的银行卡数量
            usdtCountNumber: 0, // 可绑定的数字货币数量
            walletCountNumber: 0, // 可绑定三方钱包数量
            withdrawFixed:null,
            withdrawType:0,
            checkMoneyIndex:null
        };
    },
    computed: {
        ...mapGetters(["bankArr", "userInfo"]),
        bankCardList() {
            return this.bankArr.filter(item => { return item.type == 0});
        },
        usdtList() {
            return this.bankArr.filter(item => { return item.type == 1});
        },
        walletList() {
            return this.bankArr.filter(item => { return item.type == 2});
        }
    },
    created() {
        this.getUserMoney();
        this.getGameMoneyList();
        this.getBalance();
        this.getBankCountConfig();
        setTimeout(() => {
            this.checkWithdrawPass();
        }, 1000);

    },
    methods: {
        // 检查是否设置取款密码
        checkWithdrawPass() {
            if (this.userInfo && !this.userInfo.withdrawPassWordState) {
                this.$confirm(
                    this.$t("bankCardPage.tipsPawss"),
                    {
                        confirmButtonText: this.$t("bankCardPage.determine"),
                        cancelButtonText: this.$t("bankCardPage.cancel"),
                        type: "warning",
                    }
                ).then(() => {
                    this.$router.push({ path: "/my/security/capital" });
                });
            }
        },
        checkMoney(num,index) {
            this.setmoney = num
            this.checkMoneyIndex = index
            this.onChangePhone(num)
        },
        getUserMoney() {
 
            if (this.$common.getUserBalance()) {
                this.gameList = this.$common.getUserBalance().totalBalanceDetail;
                // this.userMoney = this.$common.getUserBalance().totalBalance;
            }
        },
        // 获取银行卡绑定配置
        getBankCountConfig () {
            this.$http.get(this.$api.getSettings, "withdraw_open").then(res => {
                try {
                    this.bankCountNumber = res.data.svalue.bank_card_count; // 可绑银行卡数量
                    this.usdtCountNumber = res.data.svalue.digit_money_count; // 可绑数字货币数量
                    this.walletCountNumber = res.data.svalue.origo_money_count; // 可绑的三方钱包数量
                } catch {
                    this.bankCountNumber = 0;
                    this.usdtCountNumber = 0;
                    this.walletCountNumber = 0;
                }
            })
        },
        //一键归集
        onMergeGame() {
            if (this.OneKey) {
                setTimeout(() => {
                    this.OneKey = false;
                }, 10000);
                this.$message.error(this.$t("accountPage.warning"));
                return;
            }
            this.OneKey = true;
            let option = {
                clientId: this.$common.getUser().tenant_id, //tenant_id
                clientIp: "192.168.1.1",
                memberId: this.$common.getUser().user_id, //userid
                username: this.$common.getUser().username,
            };
            this.$http
                .post(this.$api.oneKeyBalance, option, true)
                .then((res) => {
                    if (res.code == 0) {
                        this.$message.success(this.$t("accountPage.handRes"));
                        this.getGameMoneyList();
                    }
                });
        },
        //获取游戏厂商列表
        getGameMoneyList(refour = false) {
            if (refour) {
                if (this.refreshImgTime) {
                    setTimeout(() => {
                        this.refreshImgTime = false;
                    }, 10000);
                    this.$message.error(this.$t("accountPage.warning"));
                    return;
                }
                this.refreshImgTime = true;
            }

            this.refreshImgStart = true;
            let option = {
                clientId: this.$common.getUser().tenant_id, //tenant_id
                clientIp: "192.168.1.1",
                memberId: this.$common.getUser().user_id, //userid
                username: this.$common.getUser().username,
            };
            this.$http
                .post(this.$api.getGameMoneyList, option, true)
                .then((res) => {
                    this.refreshImgStart = false;
                    if (res.code == 0 && res.data) {
                        this.$store.commit("updataUserInfo", res.data);
                        this.gameList = res.data.totalBalanceDetail;
                        this.$common.setUserBalance(res.data);
                        if (refour) {
                            this.$message.success(
                                this.$t("accountPage.Refresh")
                            );
                        }
                    }
                });
        },
        onConfirm() {
            if (!this.selectBank) {
                this.$message.error("请选择取款方式");
                return;
            }
            //验证首次提款
            this.$http.get(this.$api.firstWithdraw).then((res) => {
                if (res.data) {
                    if (this.userInfo.phone) {
                        this.mPhone = this.userInfo.phone;
                        this.showPhone = true;
                    }
                    this.dialogVisible = true;
                } else {
                    //打开取款
                    this.onSubmitDrawing();
                }
            });
        },
        onSubmitDrawing() {
            if (!/(^[1-9]\d*$)/.test(this.setmoney)) {
                this.$message({
                    message: this.$t("drawingPage.integer"),
                    type: "error",
                    duration: "2000",
                });
                return;
            }
            if (this.moneyPassword == "") {
                this.$message({
                    message: this.$t("drawingPage.inputPwass"),
                    type: "error",
                    duration: "2000",
                });
                return;
            }
            this.$freeze.freeze().then((res) => {
                if (!res) {
                    this.$message({
                        message: this.$t("drawingPage.errorTips"),
                        type: "error",
                        duration: "2000",
                    });
                } else {
                    if (this.setmoney < this.singleMin) {
                        this.$message({
                            message:
                                this.$t("drawingPage.lower") +
                                this.singleMin +
                                this.$t("drawingPage.element"),
                            type: "warning",
                        });
                        return;
                    }
                    if (this.setmoney > this.singleMax) {
                        this.$message({
                            message:
                                this.$t("drawingPage.higher") +
                                this.singleMax +
                                this.$t("drawingPage.element"),
                            type: "warning",
                        });
                        return;
                    }
                    if (this.ActualMoney <= 0) {
                        this.$message({
                            message: this.$t("drawingPage.toolow"),
                            type: "warning",
                        });
                        return;
                    }
                    var data = {
                        amount: this.setmoney,
                        bankNo: this.backitemdata[0].number,
                        bankAccount: this.backitemdata[0].account, //银行卡户名
                        bankBranch: this.backitemdata[0].branch, //	支行
                        bankName: this.backitemdata[0].name, //银行名称
                        password: this.moneyPassword,
                        handlingfee: this.handlingfee, //手续费
                        administrativeCosts: this.administrativeCosts, //行政费用,
                        discountDeduction: this.discountDeduction, //优惠扣除
                        operator: this.$common.getUser().username,
                        type: this.backitemdata[0].type,
                        digitRate: this.digitBuyRate,
                        bankId: this.backitemdata[0].id,
                    };
                    this.$http
                        .post(this.$api.entranceWithdraw, data, true)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$alert(
                                    this.$t("drawingPage.successful"),
                                    this.$t("drawingPage.tip"),
                                    {
                                        confirmButtonText: this.$t(
                                            "drawingPage.determine"
                                        ),
                                        confirmButtonClass: "",
                                        callback: (action) => {
                                            //关闭所有弹框
                                        },
                                    }
                                );
                                this.setmoney = '';
                                this.moneyPassword = '';
                                this.checkMoneyIndex = null;
                                this.getGameMoneyList();
                            } else {
                                this.textTips = this.$t(
                                    `errorCode.${res.code}`
                                );
                                this.centerIs = true;
                                this.dialogVisibletext = true;
                            }
                        });
                }
            });
        },
        //获取验证码
        getCode() {
            if (this.showPhone === false) {
                if (!/^1[3456789]\d{9}$/.test(this.mPhone)) {
                    this.$message.error(this.$t("accountPage.phoneErr"));
                    // this.phoneTips = "手机号格式错误";
                    return;
                }
            }
            this.$http
                .get(
                    this.$api.sendSmsCode +
                        "/" +
                        this.mPhone +
                        "?functionId=" +
                        3
                )
                .then((res) => {
                    if (res.code == 0) {
                        this.$message.success(
                            this.$t("accountPage.getcodeSuee")
                        );
                        this.codeButDis = true;
                        var time = 60;
                        this.intervalID = setInterval(() => {
                            time--;
                            this.codeButtext =
                                this.$t("accountPage.getcode") +
                                "(" +
                                time +
                                ")";
                            if (time == 0) {
                                this.codeButDis = false;
                                clearInterval(this.intervalID);
                                this.codeButtext = this.$t(
                                    "accountPage.getcode"
                                );
                                time = 60;
                            }
                        }, 1000);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
        },
        submitPhone() {
            let option = {
                phone: this.mPhone,
                smsCode: this.mCode,
            };
            this.$http.post(this.$api.bindPhone, option, true).then((res) => {
                if (res.code == 0) {
                    this.$message.success(this.$t("accountPage.mobile"));
                    this.dialogVisible = false;
                    this.onSubmitDrawing();
                    this.$nkhttp.getUserInfo();
                } else {
                    let msg =
                        this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                        this.$t("errorCode.webDefault");
                    this.$message.error(msg);
                }
            });
        },
        addbankList() {
            this.$router.push("/my/info/bankCard");
        },
        onMore() {
            this.condition = !this.condition;
            this.total = this.total == 19 ? this.gameList.length : 19;
        },
        onSelectbank(e) {
         console.log(e)
            this.backitemdata = [];
            if (e == "add") {
                this.backcardname = "";
                this.backImg = "";
                this.addbankList();
                return;
            }
            this.backitemdata = this.bankArr.filter((item) => {
                return item.id == e;
            });
            console.log(this.backitemdata)
            if (this.backitemdata[0].type == 1) {
                this.getDigitRate();
                this.textTips =
                    this.$t("drawingPage.tips1") +
                    "\r\n" +
                    this.$t("drawingPage.tips2") +
                    "\r\n" +
                    this.$t("drawingPage.tips4") +
                    "\r\n";
                this.dialogVisibletext = true;
            }else if (this.backitemdata[0].type == 2) {
                this.backcardname =
                    this.$t("accountPage.wallet") +
                    "(" +
                    this.backitemdata[0].name +
                    ")";
                this.backImg = this.walletimg;

                this.getDigitRate();
                this.textTips =
                    this.$t("drawingPage.tips1") +
                    "\r\n" +
                    this.$t("drawingPage.tips2") +
                    "\r\n" +
                    this.$t("drawingPage.tips4") +
                    "\r\n";
                this.dialogVisibletext = true;
            } else {
                this.backcardname =
                    this.backitemdata[0].name +
                    "(" +
                    this.backitemdata[0].number.substr(-4) +
                    ")";

                this.backImg = this.$common.getImgUrl(
                    this.backitemdata[0].imgUrl
                );
            }
            this.selectBank = true;
            this.getCost();
        },

        // 获取汇率
        getDigitRate() {
            let data = {
                digitCcy: this.backitemdata[0].name,
                digitLink: this.backitemdata[0].branch,
                type: this.backitemdata[0].type,
            };
            this.$http.post(this.$api.getDigitRate, data).then((res) => {
                if (res.code == 0) {
                    this.digitBuyRate = res.data.digitBuyRate;
                    this.exchange = this.subNum6(1 / res.data.digitBuyRate);
                    console.log(this.exchange)
                    this.currencyName = res.data.digitCcy;
                } else {
                    this.message = res.msg;
                    if (!this.showNote) {
                        this.note = true;
                    }
                    this.showNote = true;
                    this.exchange = 0;
                    this.currencyName = this.backInfo[0].name;
                }
            });
        },
        //小數點截取6位
        subNum6(val) {
            var re = /([0-9]+\.[0-9]{6})[0-9]*/;
            let aNew = (val + "").replace(re, "$1");
            return aNew;
        },
        //计算数字精度
        accMul(arg1, arg2) {
            console.log(arg1)
            console.log(arg2)
            var m = 0,
                s1 = arg1.toString(),
                s2 = arg2.toString();
            try {
                m += s1.split(".")[1].length;
            } catch (e) {}
            try {
                m += s2.split(".")[1].length;
            } catch (e) {}
            return (
                (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
                Math.pow(10, m)
            );
        },
        //获取中新钱包余额，可提现
        getBalance() {
            let option = {
                clientId: this.$common.getUser().tenant_id,
                username: this.$common.getUser().username,
            };
            this.$http.post(this.$api.queryBalance, option).then((res) => {
                if (res.code == 0) {
                    this.SureMoney = res.data.money;
                    this.placeholderPhone =
                        this.$t("drawingPage.sure") +
                        this.$common.setNumFixed(res.data.money, 2) +
                        this.$t("drawingPage.element");
                }
            });
        },
        onChangePhone(e) {
            this.handlingfee = this.handlingfees + this.setmoney*Number(this.withdrawPayRate);
            if (e && e >= 0) {
                // e = e.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
                this.ActualMoney =
                    e -
                    this.handlingfee -
                    this.administrativeCosts -
                    this.discountDeduction;
            } else {
                this.setmoney = 0
                this.ActualMoney = 0;
            }
            if (this.ActualMoney <= 0) {
                this.ActualMoney = 0;
            }
        },
        getAllMoney() {
            this.setmoney = this.$common.setNumFixed(this.SureMoney, 2);
            this.setmoney = Math.floor(this.setmoney); //setmoney
            this.onChangePhone(this.setmoney);
        },
        //获取手续费等
        getCost(start = false) {
            this.refreshImgStart = true;
            let option = {
                memberId: this.$common.getUser().user_id,
            };
            this.$http.post(this.$api.getCurrentAudit, option).then((res) => {
                this.refreshImgStart = false;
                if (res.code == 0) {
                    this.withdrawFixed = res.data.withdrawFixed ?  res.data.withdrawFixed.split(',') : res.data.withdrawFixed; // 取款整额数组
                    this.withdrawType = res.data.withdrawType; // 取款类型
                    this.withdrawPayRate = res.data.withdrawPayRate; //百分比
                    this.handlingfee = res.data.handlingfee + this.setmoney*Number(this.withdrawPayRate); //手续费
                    this.handlingfees = res.data.handlingfee; //手续费
                    this.administrativeCosts = res.data.administrativeCosts; //行政费用,
                    this.discountDeduction = res.data.discountDeduction; //优惠扣除
                    this.singleMin = res.data.singleMin;
                    this.singleMax = res.data.singleMax;
                    if (start) {
                        this.ActualMoney =
                            this.setmoney -
                            this.handlingfee -
                            this.administrativeCosts -
                            this.discountDeduction;
                        if (this.ActualMoney < 0) {
                            this.ActualMoney = 0;
                        }
                        this.$message({
                            message: this.$t("drawingPage.sucRefresh"),
                            type: "success",
                            duration: "2000",
                        });
                    }
                }
            });
        },
    },
};
</script>
<style lang="scss" >
    @import url('../../../assets/css/common.css');
.dialog {
    .el-dialog__headerbtn .el-dialog__close {
        font-size: 0.2rem !important;
        color: #313131 !important;
    }
    .el-dialog__header {
        padding: 20px 20px 10px;
    }
    .customClass {
        .el-loading-text {
            background: #000;
            color: #fff;
            font-size: 0.2rem;
        }
    }
    .el-dialog__body {
        padding: 0;
    }
    .header-title {
        text-align: center;
        color: #2d2b4d;
        font-size: 28px;

        font-weight: bold;
    }
    .content {
        padding: 20px 60px;
        .btn-submit {
            width: 100%;
            font-size: 16px;
            border: none;
            color: #fff;
            background: #ff3a2b;
            border-radius: 10px;
            margin-top: 0.4rem;
        }
        .btn-code {
            color: #fff;
            font-size: 16px;
            border: none;
            background: #ff3a2b;
            border-radius: 10px;
        }
    }
    .inputfelx {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .label {
            color: #2d2b4d;
            font-size: 16px;
            white-space: nowrap;
            width: 75px;
            flex-shrink: 0;
        }
        .input-p {
            flex-grow: 2;
        }
        .btn-code {
            margin-left: 10px;
            width: 1.5rem;
        }
    }
}
.bankimg {
    width: 0.25rem !important;
    height: 0.25rem !important;
    vertical-align: middle;
    margin-right: 0.1rem;
}
.money-select-option-add-bank {
    display: flex;
    justify-content: space-between;
    .add-text {
        flex-grow: 1;
        text-align: left;
    }
    .add-bank-img {
        // color: #ffac74;
        font-size: 0.18rem;
        padding-top: 0.08rem;
        padding-right: 0.05rem;
    }
}
.dialogCentent {
    padding: 0px 0.2rem;
    .text {
        white-space: break-spaces;
        line-height: 1.5;
    }
    .centetr {
        text-align: center;
    }
    .btnBox {
        margin-top: 0.2rem;
        text-align: center;
    }
    .btn-submit {
        color: #fff;
        font-size: 0.16rem;
        border: none;
        width: 200px;
        background: #ff3a2b;
        border-radius: 10px;
    }
}
.my-finance-withdraw {
    .flexItem {
        display: flex;
        margin-bottom: 20px;
        .flexName {
            min-width: 100px;
            font-weight: 600;
            color: #333;
            display: inline-block;
            padding-left: 20px;
            box-sizing: border-box;
            padding-top: 0.1rem;
            font-size: 0.15rem;
        }
        .inputsele {
            width: 100%;
        }
        .felxg {
            width: 400px;
            .el-input__inner {
                color: #313131;
            }
            .el-input.is-active .el-input__inner,
            .el-input__inner:focus {
                outline: 0;
            }
            .el-input__prefix,
            .el-input__suffix {
                position: absolute;
                top: 10px;
                right: 10px;
                height: 100%;
                color: #4da0fe;
                text-align: center;
                cursor: pointer;
            }
            .withdraw-buttom-box {
                margin-left: -10px;
                .withdraw-buttom {
                    display: inline-block;
                    width: 72px;
                    height: 32px;
                    text-align: center;
                    line-height: 32px;
                    border: solid #cfcfcf 1px;
                    border-radius: 8px;
                    color: #313131;
                    cursor: pointer;
                    margin-left: 10px;
                    margin-bottom: 5px;
                    &:hover {
                        color: #fa3030;
                        border-color: #fa3030;
                    }
                }
                .withdraw-buttom-act {
                    color: #fa3030;
                    border-color: #fa3030;
                }
            }
        }
        .tips {
            color: #313131;
            font-size: 0.15rem;
            p {
                margin: 0.12rem 0;
            }
            .refshImg {
                width: 0.25rem;
                height: 0.25rem;
                cursor: pointer;
            }
        }
    }

    .shuaActive {
        animation: mymove 1.25s linear infinite;
        -moz-animation: mymove 1.25s linear infinite;
        /* Firefox */
        -webkit-animation: mymove 1.25s linear infinite;
        /* Safari and Chrome */
        -o-animation: mymove 1.25s linear infinite;
        /* Opera */
    }

    @keyframes mymove {
        0% {
            -webkit-transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(720deg);
        }
    }
    .flexUser {
        display: flex;
        margin-top: 30px;
        padding-left: 20px;
        .text {
            color: #333;
            font-size: 0.17rem;
        }
        .usermoney {
            font-size: 0.19rem;
            // font-weight: bold;
            margin-top: 0.15rem;
        }
        .imgRefsh {
            width: 0.25rem;
            height: 0.25rem;
            cursor: pointer;
        }
        .btnOne {
            // background: url('../../assets/image/dze/btn.png') no-repeat;
            // background-size: cover;
            text-align: center;
            font-size: 0.16rem;
            color: #fff;
            width: 1.28rem;
            height: 0.4rem;
            line-height: .4rem;
            background: #ff3a2b;
            border-radius: 10px;
            margin-left: 33px;
            cursor: pointer;
        }
    }

    .ulBox {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0.3rem;
        border-radius: 10px;
        padding: 15px;
        width: calc(100% - 0.15rem);
        .itemBox {
            color: #313131;
            font-size: 14px;
            text-align: center;
            word-wrap: break-word;
            width: 1.2rem;
            padding: 20px 10px;
            box-sizing: border-box;
            border-right: 1px solid #f9f6f6;
            border-bottom: 1px solid #f9f6f6;
            border-bottom-right-radius: 8px;
            .moneyColor {
                color: #ff3a2b;
            }
            .vendor {
                flex: 1;
                min-width: 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .itemBox:nth-child(7n + 0) {
            margin-right: 0px;
            border-right: 0px;
        }
        .more {
            width: 1.2rem;
            box-sizing: border-box;
            line-height: 0.7rem;
            text-align: center;
            float: right;
            cursor: pointer;
            border-bottom: 1px solid #f9f6f6;
            border-bottom-right-radius: 8px;
            .moreImg {
                width: 0.2rem;
                height: 0.21rem;
            }
        }
    }

    .banklist {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        .titleB {
            min-width: 100px;
            font-weight: 600;
            color: #333;
            display: inline-block;
            padding-left: 20px;
            box-sizing: border-box;
            font-size: 0.15rem;
        }
    }
    .selectbanks {
        width: 4rem;
        .prefixSlot {
            height: 0.2rem;
            width: 0.2rem;
            margin-top: 0.11rem;
        }
        .selectbank-img {
            .el-input__inner {
                padding-left: 0.3rem;
            }
        }
    }

    .addBank {
        div {
            display: inline-block;
            height: 110px;
            width: 240px;
            cursor: pointer;
            transition: all 0.1s linear;
            margin-bottom: 0;
            border-radius: 6px;
            border: 1px solid #e6e6e6;
            border-radius: 8px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
            margin: 15px 0 10px 19px;
            opacity: 0.8;
            text-align: center;
            &:hover {
                opacity: 1;
            }
            h2 {
                font-weight: 400;
                font-size: 14px;
                margin-top: 30px;
            }
            p {
                display: inline-block;
                margin-top: 6px;
                width: 79px;
                height: 26px;
                line-height: 26px;
                border-radius: 12px;
                color: #fff;
                font-size: 12px;
                background: #4367f7;
            }
        }
    }
    .banklist {
        li {
            height: 110px;
            width: 240px;
            cursor: pointer;
            -webkit-transition: all 0.1s linear;
            transition: all 0.1s linear;
            border-radius: 6px;
            float: left;
            border: 1px solid #e6e6e6;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
            margin: 15px 15px 10px 0;
            opacity: 0.8;
            &:nth-child(3n) {
                margin-right: 0;
            }
            &:hover {
                opacity: 1;
                border-color: #dcdcdc;
            }
            img {
                margin: 15px 12px;
                width: 46px;
                float: left;
            }
            div {
                float: left;
                h2 {
                    line-height: 30px;
                    font-size: 13px;
                    margin-top: 12px;
                    color: #333;
                    font-weight: 600;
                }
                p {
                    line-height: 20px;
                    font-size: 12px;
                    color: #999;
                }
                h3 {
                    font-size: 14px;
                    margin-top: 3px;
                    color: #333;
                    line-height: 30px;
                }
            }
            &.active {
                border-color: #4ddbb8;
                box-shadow: 0 0 10px rgba(0, 188, 141, 0.25);
            }
        }
    }
    .tip {
        line-height: 42px;
        font-size: 14px;
        padding-left: 100px;
    }
    .myItems {
        .operate {
            font-size: 14px;
            color: #4367f7;
            cursor: pointer;
            margin-left: 240px;
            font-weight: bold;
        }
    }
}
</style>